"use client";

import { c as _c } from "react/compiler-runtime";
import { useLanguage } from "~/translations/loader/use-language";
import { Searchbar } from "../../filterbar/searchbar-eon";
export function FilterbarEcon() {
  const $ = _c(6);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex pb-4"><h1 className="font-bold text-5xl md:mb-2">Let's change energy. For real.</h1></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.econ_filterbar_subHL) {
    t1 = <div className="flex pb-8"><p className=" " data-source="lc">{t.econ_filterbar_subHL}</p></div>;
    $[1] = t.econ_filterbar_subHL;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex w-full md:w-1/2"><Searchbar className="w-full" /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <section className="flex w-full flex-col items-center justify-center bg-primary px-6 py-6 text-white md:px-10 md:py-10" id="filterbar" tabIndex={-1}>{t0}{t1}{t2}</section>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}